export default "<div class=\"page-column\">\n  <div *ngFor=\"let p of description\" [ngClass]=\"language === 'hebrew'? 'rtl' : ''\">{{p}}</div>\n</div>\n"